/**
 * Generic business-action values shared by every merchant. Merchant-only
 * sentinels (shade matching, lipstick guide, YSE order-issue form, ...) live in
 * their preset module under `src/merchants/`.
 */
export const TALK_TO_PRO_VALUE = '__talk_to_pro__';
export const ORDER_STATUS_VALUE = '__order_status__';
export const ORDER_REPORT_ISSUE_VALUE = '__order_report_issue__';
export const ORDER_REORDER_VALUE = '__order_reorder__';
export const ORDER_SUBSCRIBE_VALUE = '__order_subscribe__';
export const RETURN_EXCHANGE_TRIGGER = '__return_exchange__';
/** Normalized chip labels that map to `RETURN_EXCHANGE_TRIGGER`. */
export const RETURN_EXCHANGE_LABELS = new Set([
  'return / exchange',
  'return/exchange',
  'return exchange',
  'return or exchange',
]);
export const PRODUCT_QUESTION_VALUE = '__product_question__';
export const START_NEW_CHAT_VALUE = '__start_new_chat__';
export const ORDER_ISSUE_VALUES = new Set([
  '__order_issue_damaged__',
  '__order_issue_defective__',
  '__order_issue_wrong_items__',
  '__order_issue_missing_items__',
  '__order_issue_refund__',
  '__order_issue_edit__',
  '__order_issue_lost_stolen__',
  '__order_issue_other__',
]);
export const RETURN_EXCHANGE_REASON_WRONG_SHADE_VALUE = '__return_exchange_wrong_shade__';
export const RETURN_EXCHANGE_REASON_TOO_CAKEY_VALUE = '__return_exchange_too_cakey__';
export const RETURN_EXCHANGE_REASON_TOO_EXPENSIVE_VALUE = '__return_exchange_too_expensive__';
export const RETURN_EXCHANGE_REASON_WRONG_DAMAGED_VALUE = '__return_exchange_wrong_damaged__';
export const RETURN_EXCHANGE_REASON_WRONG_TINT_VALUE = '__return_exchange_wrong_tint__';
export const RETURN_EXCHANGE_REASON_DAMAGED_DEFECTIVE_VALUE =
  '__return_exchange_damaged_defective__';
export const RETURN_EXCHANGE_REASON_INCORRECT_ITEM_VALUE = '__return_exchange_incorrect_item__';
export const RETURN_EXCHANGE_REASON_CHANGED_MIND_VALUE = '__return_exchange_changed_mind__';
export const RETURN_EXCHANGE_REASON_SKIN_SENSITIVITY_VALUE = '__return_exchange_skin_sensitivity__';
export const RETURN_EXCHANGE_REASON_OTHER_VALUE = '__return_exchange_other__';
export const RETURN_EXCHANGE_REASON_LABELS: Record<string, string> = {
  [RETURN_EXCHANGE_REASON_WRONG_SHADE_VALUE]: 'Wrong Shade',
  [RETURN_EXCHANGE_REASON_TOO_CAKEY_VALUE]: 'Too Cakey',
  [RETURN_EXCHANGE_REASON_TOO_EXPENSIVE_VALUE]: 'Too Expensive',
  [RETURN_EXCHANGE_REASON_WRONG_DAMAGED_VALUE]: 'Received Wrong / Damaged Item',
  [RETURN_EXCHANGE_REASON_WRONG_TINT_VALUE]: 'Wrong Tint',
  [RETURN_EXCHANGE_REASON_DAMAGED_DEFECTIVE_VALUE]: 'Product is damaged or defective',
  [RETURN_EXCHANGE_REASON_INCORRECT_ITEM_VALUE]: 'Incorrect item received',
  [RETURN_EXCHANGE_REASON_CHANGED_MIND_VALUE]: 'No longer needed / changed my mind',
  [RETURN_EXCHANGE_REASON_SKIN_SENSITIVITY_VALUE]: 'Skin sensitivity or irritation',
  [RETURN_EXCHANGE_REASON_OTHER_VALUE]: 'Other (please specify)',
};
export const RETURN_EXCHANGE_REASON_VALUES = new Set([
  RETURN_EXCHANGE_REASON_WRONG_SHADE_VALUE,
  RETURN_EXCHANGE_REASON_TOO_CAKEY_VALUE,
  RETURN_EXCHANGE_REASON_TOO_EXPENSIVE_VALUE,
  RETURN_EXCHANGE_REASON_WRONG_DAMAGED_VALUE,
  RETURN_EXCHANGE_REASON_WRONG_TINT_VALUE,
  RETURN_EXCHANGE_REASON_DAMAGED_DEFECTIVE_VALUE,
  RETURN_EXCHANGE_REASON_INCORRECT_ITEM_VALUE,
  RETURN_EXCHANGE_REASON_CHANGED_MIND_VALUE,
  RETURN_EXCHANGE_REASON_SKIN_SENSITIVITY_VALUE,
  RETURN_EXCHANGE_REASON_OTHER_VALUE,
]);
export const LIVE_AGENT_HANDOFF_VALUE = '__live_agent_handoff__';
export const KLAVIYO_FORM_ID = 'klaviyo_subscribe';
export const RECHARGE_SUBSCRIPTION_EMAIL_FORM_ID = 'recharge_subscription_verify_email';
export const RECHARGE_SUBSCRIPTION_ACTION_LABELS: Record<string, string> = {
  __recharge_subscription_skip__: 'Skip',
  __recharge_subscription_reschedule__: 'Reschedule',
  __recharge_subscription_frequency__: 'Frequency',
  __recharge_subscription_add__: 'Add',
  __recharge_subscription_swap__: 'Swap',
  __recharge_subscription_cancel__: 'Cancel',
  __recharge_subscription_other__: 'Other',
};
/**
 * Normalized chip labels that map to `TALK_TO_PRO_VALUE`. Generically this is a
 * live-agent handoff; merchant presets may override it (NoMakeupMakeup routes it
 * to shade matching and adds its selfie labels in its own preset).
 */
export const TALK_TO_PRO_LABELS = new Set([
  'talk to a pro',
  'talk to pro',
  'talk with a pro',
  'ask a pro',
  'ask pro',
]);
export const PRODUCT_QUESTION_LABELS = new Set([
  'product question',
  'product questions',
  'product support',
]);
export const LIVE_AGENT_LABELS = new Set([
  'talk to a live agent',
  'talk to live agent',
  'talk to a human',
  'talk to human',
]);
export const START_NEW_CHAT_LABELS = new Set([
  'start a new chat',
  'start new chat',
  'new chat',
  'start over',
]);
